import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'

import './Header.scss'
import logomark from './images/logomark.svg'

export const Header = ({ project, t }) => {
  return (
    <header className="c-print-header">
      <div className="c-print-header__brand">
        <img alt="" className="c-print-header__brand-logo" src={logomark} />
        <span className="c-print-header__brand-title">
          {t('navigation.projects')}
        </span>
      </div>

      <div className={`c-print-header__hero u-clearfix`}>
        <img
          alt=""
          className="c-print-header__image"
          height="50"
          src={project.heroImage}
        />
        <h1 className={`c-print-header__title`}>{project.title}</h1>
        <p className="c-print-header__description">{project.description}</p>
      </div>
    </header>
  )
}

Header.propTypes = {
  project: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}

export default withNamespaces('translations')(Header)
